import { useLocation } from 'react-router-dom';
import { SettingsSubLayout } from 'containers/SettingsPage/SettingsLayout';

enum SectionSegments {
  Profile = 'profile',
  Locations = 'locations',
  TeamMembers = 'team-members',
  Rules = 'rules',
}

const CompanySettings = () => {
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;
  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Profile;

  return (
    <SettingsSubLayout
      items={[
        {
          label: 'Profile',
          iconName: 'building-complex',
          to: '/settings/company/profile',
          isActive: selectedSection === SectionSegments.Profile,
        },
        {
          label: 'Locations',
          iconName: 'map-pin',
          to: '/settings/company/locations',
          isActive: selectedSection === SectionSegments.Locations,
        },
        {
          label: 'Team Members',
          iconName: 'users',
          to: '/settings/company/team-members',
          isActive: selectedSection === SectionSegments.TeamMembers,
        },
        {
          label: 'Rules',
          iconName: 'shield-user',
          to: '/settings/company/rules',
          isActive: selectedSection === SectionSegments.Rules,
        },
      ]}
    />
  );
};

export default CompanySettings;
